import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useError from 'hooks/useError';
import { Button, Modal, Notification, Typography } from '../../../components';
import styles from './Notifications.module.scss';

export default memo(function Notifications() {
  const { t } = useTranslation('common');
  const { error, removeError } = useError();

  const reload = useCallback(() => {
    window.location.reload();
  }, []);

  if (error?.type === 'modal') {
    return (
      <Modal className={styles.modal} dataTest="error-modal">
        <Typography size="m" className={styles.message}>
          {error.message}
        </Typography>
        <Button onClick={reload}>{t('retry')}</Button>
      </Modal>
    );
  }

  if (error?.type === 'notification') {
    return (
      <div className={styles.notification}>
        <Notification onClose={removeError} dataTest="error-notification">
          {error.message}
        </Notification>
      </div>
    );
  }

  return null;
});
